import React from 'react';
import properties from '../../../constants/Properties';
import { AudioItemRenderer } from '../menus/AudioItemRenderer';
import audioEditorUtils from '../utils/AudioEditorUtils';
import { connect } from 'react-redux';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';

export const AudioTrackContent = React.createClass({
    render() {
        var height = audioToolUtils.timelineHeight();
        var backgroundColor = properties.SLIDE_VIEWER_BACKGROUND;

        if (this.props.isSelected)
            backgroundColor = '#999A9C';

        var menuStyle = {
            position: 'absolute',
            left: 0,
            width: this.props.trackWidth,
            height,
            background: backgroundColor
        };

        var elements = [];
        var i;

        for (i=0; i<this.props.audios.length; i++) {
            elements.push(<AudioItemRenderer windowHeight={this.props.windowHeight} trackWidth={this.props.trackWidth} audio={this.props.audios[i]} key={'audioItem_' + this.props.index + '_' + this.props.audios[i].uuid} zoomValue={this.props.zoomValue} dispatch={this.props.dispatch} index={this.props.index} audioIndex={i} timelinesLength={this.props.timelinesLength}/>);
        }

        var lineSize = properties.LINE_SIZE;
        var delimitators = audioToolUtils.isAudioTool() ? []: audioEditorUtils.getDelimitators();
        var delmimitatorLines = [];
        var i;
        var offset = 10;

        for (i=0; i<delimitators.length; i++) {
            const delimitatorStyle = {
                position: 'absolute',
                width: lineSize,
                left: delimitators[i],
                top: offset + 1,
                height: height - 2 * offset,
                background: '#C1C1C1'
            };

            delmimitatorLines.push(<div style={delimitatorStyle} key={'delimitator_' + this.props.index + '_' + i}/>);
        }

        return (
            <div style={menuStyle}>
                {delmimitatorLines}
                {elements}
            </div>
        );
    }
});

function mapStateToProps(state) {
    const refreshAudioTrack = state.audioEditor.refreshAudioTrack;

    return {
        refreshAudioTrack
    };
}

export const AudioTrack = connect(mapStateToProps)(AudioTrackContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioTrack.js
 **/